<template>
    <div>
        <b-modal v-model="modalIsOpen" :width="960" :on-cancel="closeAndResetModal">
            <b-loading v-model="isLoading" :is-full-page="false" />
            <template>
                <header class="px-4 py-3 has-background-secondary shadow-sm">
                    <h4 class="h4 p-0 mb-0">
                        {{ $t('wordpress_modal.title') }}
                    </h4>
                </header>
                <div class="card-content">
                    <div class="content">
                        <div class="form-group">
                            <label class="label" for="url">{{ $t('partenaire-site.mainurl') }}</label>
                            <b-input v-model="formData.url" :disabled="true" />
                        </div>

                        <div class="form-group w-100">
                            <b-field label="API Token">
                                <b-input
                                    v-model="formData.api_key"
                                    placeholder="Token"
                                    class="w-100"
                                    type="password"
                                    password-reveal
                                />
                                <p class="control">
                                    <b-button
                                        type="is-secondary"
                                        :label="$t('wordpress_modal.check_button')"
                                        @click.prevent="checkApiKey"
                                    />
                                </p>
                            </b-field>
                            <b-notification v-if="errorApiKey" :closable="false" type="is-danger is-light" role="alert">
                                {{ errorApiKey }}
                            </b-notification>
                            <b-notification
                                v-if="apiKeyIsValid"
                                :closable="false"
                                type="is-success is-light"
                                role="alert"
                            >
                                <i class="far fa-check-circle mr-2" />
                                {{ $t('wordpress_modal.success') }}
                            </b-notification>
                        </div>

                        <div class="buttons justify-content-end">
                            <button class="button is-light" @click.prevent="closeAndResetModal">
                                {{ $t('global.cancel') }}
                            </button>
                            <button class="button is-danger" @click.prevent="deleteWP">
                                {{ $t('global.delete') }}
                            </button>
                            <button class="button is-secondary" :disabled="!apiKeyIsValid" @click.prevent="save">
                                {{ $t('global.save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'PartnerSiteWPModal',
        props: ['data'],
        data() {
            return {
                modalIsOpen: false,
                editMode: false,

                formData: null,
                errorApiKey: '',
                isLoading: false,
                apiKeyIsValid: false
            }
        },

        watch: {
            formData(newValue) {
                this.formData = newValue
            }
        },

        created() {
            this.formData = this.data
        },

        methods: {
            save() {
                this.$emit('saveWordpressPlugin', {
                    api_key: this.formData.api_key,
                    id: this.formData.id
                })
                this.closeAndResetModal()
            },
            deleteWP() {
                this.$emit('saveWordpressPlugin', {
                    api_key: null,
                    id: this.formData.id
                })
                this.closeAndResetModal()
            },

            checkApiKey() {
                this.errorApiKey = ''
                this.apiKeyIsValid = false

                if (!this.formData.api_key.length || this.formData.api_key.length < 6) {
                    this.errorApiKey = 'Invalid API key'
                    return
                }

                this.isLoading = true

                this.axios
                    .post(`/partner-sites/${this.formData.id}/wordpress/check-plugin`, {
                        api_key: this.formData.api_key
                    })
                    .then(response => {
                        this.apiKeyIsValid = true
                    })
                    .catch(error => {
                        this.errorApiKey = error.response.data.message
                    })
                    .finally(() => (this.isLoading = false))
            },

            openModal(site) {
                this.modalIsOpen = true

                this.formData = site
            },

            closeAndResetModal() {
                this.modalIsOpen = false
                this.apiKeyIsValid = false
                this.errorApiKey = ''

                this.formData = {
                    url: '',
                    api_key: '',
                    id: ''
                }
            }
        }
    }
</script>

<style>
    label[for^='scrape_'] {
        color: #363636;
        display: block;
        font-size: 1rem;
        font-weight: 700;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
